import { Form } from '../../types';

export const formatDate = (value: string) =>
  new Date(value).toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });

export const formTypeLabel = (form: Form) =>
  form.formType === 'single' ? 'Single Page' : 'Multi-Step';

export const responseCountLabel = (form: Form) => {
  const count = form.responseCount || 0;
  return `${count} ${count === 1 ? 'response' : 'responses'}`;
};

export const formPaths = (tenantId: string) => ({
  create: `/tenant/${tenantId}/form/create`,
  edit: (formId: string) => `/tenant/${tenantId}/form/${formId}/edit`,
  view: (formId: string) => `/tenant/${tenantId}/form/${formId}/view`,
  responses: (formId: string) => `/tenant/${tenantId}/form/${formId}/responses`,
});

export const publicFormUrl = (tenantId: string, formId: string) =>
  `${window.location.origin}${formPaths(tenantId).view(formId)}`;

export { copyToClipboard } from '../../utils/clipboard';
